import React, { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector, useWidgetParam } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { loadAdderState } from '@src/stores/product';
import { loadProductUpsellOffers } from '@src/stores/productUpsell';
import { completeCartSelector } from '@src/features/cart/store/cart';
import usePackageIdParam from '@src/hooks/usePackageIdParam';
import useBreakpoint from '@src/hooks/useBreakpoint';
import useFeatureFlag from '@src/hooks/useFeatureFlag';
import ProductAdderComponentSwitcher from './ProductAdderComponentSwitcher';

const ProductAdder = () => {
  const id = useWidgetId();
  const dispatch = useAppDispatch();
  const productId = useWidgetParam('product-id');
  const packageId = usePackageIdParam();

  const { isDesktop: autoSelectFirstProduct } = useBreakpoint();
  const { isFeatureFlagEnabled } = useFeatureFlag();

  const enableModal = useWidgetParam('enable-modal');

  const showAsModal = useMemo(() => enableModal && enableModal == 'true', [enableModal]);
  const isProductUpsellEnabled = isFeatureFlagEnabled('PR-4007-upsell');

  const { cart } = useAppSelector(completeCartSelector);
  const cartId = cart?.id;

  useEffect(() => {
    if (productId || packageId) {
      dispatch(loadAdderState(id, productId, packageId, autoSelectFirstProduct));
    }
  }, [dispatch, id, packageId]);

  useEffect(() => {
    if (isProductUpsellEnabled && productId && !packageId && cartId) {
      dispatch(loadProductUpsellOffers(productId));
    }
  }, [dispatch, isProductUpsellEnabled, productId, packageId, cartId]);

  return <ProductAdderComponentSwitcher showAsModal={!!showAsModal} packageId={packageId} />;
};

export default ProductAdder;
